module.exports = __webpack_public_path__ + "static/media/transmitter.fef7521a.jpg";